import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import styled from 'styled-components';
export const Container = styled.a `
  overflow: hidden;
  text-decoration: none;
  display: block;
  height: 100%;
  max-width: 556px;

  &:focus {
    outline: none;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: ${brand.black};
  }
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const MediaHolder = styled.div `
  --imageRatio: 340 / 250;
  --svgSize: 60px;

  display: flex;
  place-items: center;
  place-content: center;
  position: relative;
  overflow: hidden;
  border-radius: ${fluid(25, 50)};
  aspect-ratio: var(--imageRatio);
  background-color: var(--cardPlaceholderBgColor);

  @media ${from(Device.TabletSmall)} {
    --imageRatio: 311 / 420;
    --svgSize: 88px;
  }

  svg {
    width: var(--svgSize);
    ${transition('transform')}

    ${Container}:hover & {
      transform: scale(1.05);
    }
  }

  ${Container}[data-square='true'] & {
    --imageRatio: 1 / 1;

    @media ${from(Device.TabletSmall)} {
      --imageRatio: 1 / 1;
    }
  }
`;
const Image = styled.img `
  aspect-ratio: var(--imageRatio);
  object-fit: cover;
  ${transition('transform')}

  ${Container}:hover & {
    transform: scale(1.05);
  }

  ${Container}[data-square='true'] & {
    width: 100%;
    height: 100%;
  }
`;
const ContentArea = styled.div `
  position: relative;
  flex: 1;
`;
const ContentInner = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 17px 0;
  color: ${brand.grey.grey11};
`;
const Caption = styled.span `
  display: flex;
  place-items: center;
  gap: 16px;
  font-size: 13px;
  line-height: 32px;
  ${fonts.montserrat.medium};
  margin-bottom: 23px;

  &::before {
    content: '';
    width: 40px;
    height: 4px;
    background-color: var(--cardPlaceholderBgColor);
  }
`;
const Title = styled.h3 `
  font-size: 18px;
  line-height: 24px;
  ${fonts.montserrat.medium};
  margin-bottom: 11px;
`;
const Intro = styled.p `
  ${paragraphSmall};
  margin-bottom: 13px;
`;
const FakeButton = styled.div `
  margin-top: auto;
  pointer-events: none;

  ${Container}:hover & {
    ${ButtonStyles.ButtonInner} {
      --textAltColour: ${brand.grey.grey16};
      --hoverColour: ${brand.green.light};

      &::after {
        background-color: var(--hoverColour);
      }
    }

    ${ButtonStyles.Text} {
      transform: translateY(-2px);
    }
  }
`;
export const ArticleCardStyles = {
    Caption,
    Container,
    ContentArea,
    ContentInner,
    FakeButton,
    Image,
    Inner,
    Intro,
    MediaHolder,
    Title,
};
